import {Platform} from 'react-native';

import {DeviceSize} from '../../../../theme/helpers';
import {useStyles} from '../../../../hooks/styles';
import {SnackbarNotification} from '../../model';

export const GetStyles = (notification: SnackbarNotification) => {
  const styles = useStyles(({theme, mediaOnly, align}) => ({
    container: {
      paddingVertical: 7,
      paddingHorizontal: 25,
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: 20,
      borderRadius: 2,
      minHeight: 56,
      flexGrow: 0,
      ...mediaOnly(
        DeviceSize.desktop,
        {
          minWidth: 342,
          maxWidth: 724,
        },
        {
          minWidth: 320,
          maxWidth: '100%',
        },
      ),
    },
    ['container' + notification.type]: {
      backgroundColor: theme.snackbar.colors[notification.type].backgroundColor,
    },
    iconWrapper: {
      marginRight: 10,
      marginTop: 13,
      width: align(16),
      height: align(16),
    },
    close: {
      marginLeft: 10,
      marginTop: Platform.OS !== 'android' ? 13 : 8,
      width: 16,
      height: 16,
      //padding: 5,
      zIndex: 100,
    },
    message: {
      flexShrink: 1, // TODO what is this? no reason to use flexShrink and flexGrow together
      flexGrow: 1,
      marginTop: Platform.OS !== 'android' ? 2 : 0,
      paddingVertical: 9,
    },
    messageText: {
      ...theme.fonts.action,
      color: theme.color.whiteTextColor,
    },
    actionIcon: {
      color: theme.color.whiteTextColor,
    },
  }));

  return styles;
};
